import { gql } from '@apollo/client'

const MENU_TITLE_NODE_FRAGMENT = gql`
  fragment MenuTitleNodeFragment on MenuTitleNode {
    id
    autoeatId
    menuId
    idPath
    parentId
    title
    styledTitle
    titlePath
    description
    styledDescription
    translatedDescription
    level
    dietDescriptors
    allergenDescriptors
    addonDescriptors
    miscDescriptors
    nutritionDescriptors
    dishTypeId
    certainty
    isPublished

    children {
      id
      autoeatId
      menuId
      idPath
      parentId
      title
      styledTitle
      titlePath
      description
      styledDescription
      translatedDescription
      level
      dietDescriptors
      allergenDescriptors
      addonDescriptors
      miscDescriptors
      nutritionDescriptors
      dishTypeId
      certainty
      isPublished

      children {
        id
        autoeatId
        menuId
        idPath
        parentId
        title
        styledTitle
        titlePath
        description
        styledDescription
        translatedDescription
        level
        dietDescriptors
        allergenDescriptors
        addonDescriptors
        miscDescriptors
        nutritionDescriptors
        dishTypeId
        certainty
        isPublished

        children {
          id
          autoeatId
          menuId
          idPath
          parentId
          title
          styledTitle
          titlePath
          description
          styledDescription
          translatedDescription
          level
          dietDescriptors
          allergenDescriptors
          addonDescriptors
          miscDescriptors
          nutritionDescriptors
          dishTypeId
          certainty
          isPublished

          children {
            id
            autoeatId
            menuId
            idPath
            parentId
            title
            styledTitle
            titlePath
            description
            styledDescription
            translatedDescription
            level
            dietDescriptors
            allergenDescriptors
            addonDescriptors
            miscDescriptors
            nutritionDescriptors
            dishTypeId
            certainty
            isPublished
          }

          children {
            id
            autoeatId
            menuId
            idPath
            parentId
            title
            styledTitle
            titlePath
            description
            styledDescription
            translatedDescription
            level
            dietDescriptors
            allergenDescriptors
            addonDescriptors
            miscDescriptors
            nutritionDescriptors
            dishTypeId
            certainty
            isPublished

            children {
              id
              autoeatId
              menuId
              idPath
              parentId
              title
              styledTitle
              titlePath
              description
              styledDescription
              translatedDescription
              level
              dietDescriptors
              allergenDescriptors
              addonDescriptors
              miscDescriptors
              nutritionDescriptors
              dishTypeId
              certainty
              isPublished
            }
          }
        }
      }
    }
  }
`

export default MENU_TITLE_NODE_FRAGMENT
